import {
  FormPageInputItem,
  FormPageInputItemFileUpload,
  FormPageInputItemFileUploadPiclib,
  INPUT_ITEM_TYPE,
  FILE_UPLOAD_PROPERTY_INPUT_TYPE,
  FileUploadProperty,
} from 'shared';

const handlePiclib = (
  formPageInputItem?: FormPageInputItem,
): FormPageInputItemFileUploadPiclib => {
  const inputItemType = INPUT_ITEM_TYPE.fileUploadPiclib;
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.fileUploadPiclib) {
    return {
      inputItemType,
      fileSrn: formPageInputItem.fileSrn || '',
    };
  }
  return {
    inputItemType,
    fileSrn: '',
  };
};

export const convertFileUploadInitialValue = (
  property: FileUploadProperty,
  formPageInputItem?: FormPageInputItem,
): FormPageInputItemFileUpload => {
  switch (property.inputFormat.inputType) {
    case FILE_UPLOAD_PROPERTY_INPUT_TYPE.piclib: {
      return handlePiclib(formPageInputItem);
    }
  }
};
